import React from "react";
import { Link } from "react-router-dom";

export default function HoteleriaSanPedro({ bgColor }) {
  return (
    <>
      <section
        id="hoteleria"
        className={`contact-us ptb-100 ${bgColor ? "gray-light-bg" : ""}`}
      >
        <section className="team-member-section ptb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-7 col-md-8">
                <div className="section-heading text-center mb-4">
                <h2>HOTELERIA EXCLUSIVA</h2>
                <h3>All inclusive</h3>
                  <p className="lead">
                    Howard Johnson exclusivo a solo 150km, único en su categoría
                    para el Turismo Estudiantil Primario. Sus instalaciones
                    ofrecen un Servicio Premium, en un marco de plena
                    naturaleza. Las instalaciones cuentan con piscinas cubiertas
                    y descubiertas, restaurant, lobby Bar, Up Point, SUM, Deck,
                    Spa & Relax, Playa privada, WiFi, cajas de seguridad,
                    cerradura con tarjeta magnética, cámaras de seguridad,
                    consultorio médico, control ID y comidas ALL INCLUSIVE
                  </p>
                  {/* <p className="lead">
                    Consultorio Médico/Calefacción Central Cajas de Seguridad /
                    Vista al mar Desfibrilador / Piscina / Play Room Tarjeta
                    Magnética / Plancha Secador de Pelo / Smart TV Wi-Fi/Open
                    Bar 24hs Drugstore/Discoteca / UP Look
                  </p> */}
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                  <div className="team-image">
                    <img
                      src="assets/img/sanpedro/SanPedro-Hmarina.jpg"
                      alt="Team Members"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-0">Howard Johnson Marinas</h5>
                    <h6>San Pedro Costa</h6>
                    <ul className="list-inline team-social social-icon my-4 text-white">
                      <li className="list-inline-item">
                        <Link
                          target="_blank"
                          rel="noopener noreferrer"
                          to="https://www.facebook.com/hjsanpedro"
                        >
                          <span className="ti-facebook"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          to="https://instagram.com/hjsanpedro/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span className="ti-instagram"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          to="https://www.youtube.com/user/hjsanpedro"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span className="ti-youtube"></span>
                        </Link>
                      </li>
                    </ul>
                    <a
                      href="https://www.hjsanpedroresort.com.ar/home.html"
                      target="_blank"
                      rel="noreferrer"
                      className="btn app-store-btn"
                    >
                      Ver hotel
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                  <div className="team-image">
                    <img
                      src="assets/img/sanpedro/SanPedro-HCentro.jpg"
                      alt="Team Members"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-0">Howard Johnson</h5>
                    <h5 className="mb-0">Centro Hotel & Spa</h5>
                    <h6>San Pedro Centro</h6>
                    <ul className="list-inline team-social social-icon my-4 text-white">
                      <li className="list-inline-item">
                        <Link
                          to="https://www.facebook.com/hjsanpedro"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span className="ti-facebook"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          to="https://instagram.com/hjsanpedro/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span className="ti-instagram"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          to="https://www.youtube.com/user/hjsanpedro"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span className="ti-youtube"></span>
                        </Link>
                      </li>
                    </ul>
                    <a
                      href="https://www.hjsanpedro.com.ar/home.html"
                      target="_blank"
                      rel="noreferrer"
                      className="btn app-store-btn"
                    >
                      Ver hotel
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
}
